import { toZonedTime } from "date-fns-tz";
import { format, isToday } from "date-fns";
import { textCase } from "../ui/UI";
import UtilityHelper from "../utilities/UtilityHelper";

export const toInputDate = (date: Date | string): string => {
  return textCase(format(date, "d MMM yyyy"));
};

export const toSaveDate = (date: Date | string): string => {
  return format(date, "yyyy-MM-dd");
};

export const toSaveTime = (time: string): string => {
  let formatted = "";
  if (UtilityHelper.isNotEmpty(time)) {
    const [hour, minute] = time.split(":").map(Number);

    const now = new Date();
    const fullDate = new Date(
      now.getFullYear(),
      now.getMonth(),
      now.getDate(),
      hour,
      minute,
      0 // seconds
    );

    // Format to "HH:mm:ss"
    formatted = fullDate.toLocaleTimeString("en-GB", { hour12: false }); // returns e.g. "14:05:00"
  }

  return formatted;
};

// CHAT LIST
export const toLocalDate = (
  utcDate: Date | string,
  formatting: string = "dd/MM/yy",
  fullDate: boolean = false
): string => {
  const date = new Date(utcDate);
  //const timeZone = "America/New_York";
  //console.log(Intl.DateTimeFormat().resolvedOptions().timeZone);
  const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone; // local timezone

  const localDate = toZonedTime(date, timeZone);
  let formatted = UtilityHelper.isValidDate(date)
    ? (fullDate
        ? format(date, formatting)
        : isToday(date)
        ? formatTimestampIntl(localDate)
        : format(date, formatting)
      ).toLowerCase()
    : "";

  /*  let formatted = UtilityHelper.isValidDate(date)
    ? (fullDate
        ? format(date, formatting)
        : isToday(date)
        ? format(localDate, "p")
        : format(date, formatting)
      ).toLowerCase()
    : ""; */

  return formatted;
};

export const getSecondsDiff = (utcDate: Date): number => {
  /* console.log(utcDate);
  utcDate = new Date(utcDate).toISOString();
  console.log(utcDate);

  const date = new Date();
  const isoString = date.toISOString();
  console.log(isoString); */

  // Remove time portion for both dates
  /*  const today = new Date();
  const todayStr = today.toISOString();

  const timestamp: number = new Date(utcDate).getTime();
  const valStr = new Date(utcDate).toISOString();

  console.log(todayStr, valStr); */

  /* const today = new Date();

  // Ensure it's a Date object
  const d = new Date(utcDate);

  // Apply timezone offset (same idea as your Dart code)
  const offsetMs = new Date().getTimezoneOffset() * -60000;
  const localDate = new Date(d.getTime() + offsetMs);


  const diff: number = Math.floor(
    (today.getTime() - localDate.getTime()) / 1000
  );
  console.log(diff, today, localDate, utcDate);
  //return 5 * 60; //;
  console.log(5 * 60);
  console.log(differenceInSeconds(today, localDate)); */

  return 5 * 60;
};

// CHAT GROUP DATE
export const getDateUptoDate = (val: Date): string => {
  const today = new Date();

  // Remove time portion for both dates
  const todayStr = today.toISOString().split("T")[0];
  const valStr = val.toISOString().split("T")[0];

  if (todayStr === valStr) {
    return "today";
  } else {
    // Format date as "d MMM yyyy"
    const day = val.getDate();
    const month = val.toLocaleString("en-US", { month: "short" }).toLowerCase();
    const year = val.getFullYear();
    return `${day} ${month} ${year}`.toLowerCase();
  }
};

// MESSAGES TIME
export const formatTimestampIntl = (date: Date): string => {
  /*  return new Intl.DateTimeFormat("en-US", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  }).format(date); */

  // Ensure it's a Date object
  const d = new Date(date);

  // Apply timezone offset (same idea as your Dart code)
  const offsetMs = new Date().getTimezoneOffset() * -60000;
  const localDate = new Date(d.getTime() + offsetMs);

  // Extract hours & minutes
  let hours = localDate.getHours();
  const minutes = String(localDate.getMinutes()).padStart(2, "0");

  // AM/PM logic
  const ampm = hours >= 12 ? "PM" : "AM";
  hours = hours % 12 || 12; // convert to 12-hour format

  return `${String(hours).padStart(2, "0")}:${minutes} ${ampm}`;
};
